import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";

export const myAccountStyle = StyleSheet.create({
    container: {
        flex: 1
    },
    loader: {
        flex: 1, alignItems: 'center', justifyContent: 'center', backgroundColor: appColors.lightBackgroundColor
    },
    innerContainer: {
        flex: 1, backgroundColor: appColors.lightBackgroundColor
    },
    containerView: {
        marginBottom: 20, flex: 1
    },
    innerView: {
        flex: 0.4
    },
    cardContainer: {
        paddingBottom: 0, elevation: 0, borderColor: 'transparent', borderRadius: 10,
    },
    profileView: {
        alignSelf: 'center', alignItems: 'center'
    },
    cameraView: {
        position: 'absolute',
        height: 35,
        width: 35,
        borderRadius: 17,
        backgroundColor: appColors?.primary,
        justifyContent: 'center',
        alignItems: 'center',
        bottom: 8,
        right: 0
    },
    contentView: {
        flexDirection: 'row', alignItems: 'center',
    },
    notesView: {
        flexDirection: 'row', marginRight: 10, alignSelf: 'flex-start', flex: 1
    },
    deactivateNotesView: {
        flex: 1, marginTop: 10
    },
    deactivateStyle: {
        flexDirection: 'row', marginRight: 10, alignSelf: 'flex-start', flex: 1
    },
    informationView: {
        flex: 0.6, flexDirection: 'column',
    },
    informationContainer: {
        elevation: 0, borderColor: 'transparent', borderRadius: 10, paddingHorizontal: 0, paddingBottom: 0, paddingVertical: 0
    },
    subHeaderView: {
        flexDirection: 'row', justifyContent: 'space-between', paddingHorizontal: 15
    },
    buttonView: {
        flexDirection: 'row', alignSelf: 'flex-end',
    },
    deleteIconView: {
        borderWidth: 1, borderRadius: 10, padding: 5, marginHorizontal: 2, borderColor: appColors.lightBackgroundColor, backgroundColor: appColors.lightRed, marginLeft: 15
    },
    labelStyle: {
        color: appColors.labelColor, fontSize: fontSize.smallerFontSize, fontFamily: appFonts.medium
    },
    inputStyle: {
        fontSize: fontSize.smallerFontSize, color: appColors.lightDark, fontFamily: appFonts.medium
    },
    inputContainerStyle: {
        borderColor: appColors.borderColor,
        paddingLeft: 5
    },
    passwordContainer: {
        elevation: 0, borderColor: 'transparent', borderRadius: 10, paddingHorizontal: 0, marginBottom: 0, paddingVertical: 0
    },
    headerView: {
        flex: 1, alignItems: 'center', justifyContent: 'center',
    },
    headerStyle: {
        padding: 13, backgroundColor: appColors.lightBackgroundColor, justifyContent: 'space-between', flexDirection: 'row', borderTopLeftRadius: 10, borderTopRightRadius: 10,
    },
    cardStyle: {
        margin: 0, paddingBottom: 0
    },
    updateBtnView: {
        flexDirection: 'row', justifyContent: 'flex-end', borderTopWidth: 0.2, backgroundColor: appColors.light, borderColor: appColors.lightGrey, paddingBottom: 21, borderBottomLeftRadius: 10, borderBottomRightRadius: 10,
    },
    buttonStyle: {
        marginTop: 20, borderRadius: 7, borderColor: appColors.primary, borderWidth: 0.5
    },
    titleStyle: {
        fontSize: fontSize.mediumFontSize, fontFamily: appFonts.bold, marginHorizontal: 7,
    },
    updateButtonStyle: {
        marginTop: 20, borderRadius: 7, marginHorizontal: 15, right: 3, marginRight: 13, borderWidth: 0.5
    },

    // ---- Card layout (matches Order Settings cards) ----
    scrollContent: {
        paddingBottom: 40,
    },
    columns: {
        alignItems: 'flex-start',
    },
    summaryColumn: {
        flex: 0.38,
    },
    detailsColumn: {
        flex: 0.62,
    },
    summaryCard: {
        alignItems: 'center',
    },
    avatarWrapper: {
        marginTop: 4,
        marginBottom: 12,
    },
    avatar: {
        height: 110,
        width: 110,
        borderRadius: 55,
        borderWidth: 3,
        borderColor: appColors.lightPrimary,
    },
    profileName: {
        fontSize: fontSize.largerFontSize,
        fontFamily: appFonts.bold,
        color: appColors.dark,
        textAlign: 'center',
    },
    roleBadge: {
        marginTop: 6,
        paddingHorizontal: 12,
        paddingVertical: 4,
        borderRadius: 12,
        backgroundColor: appColors.lightPrimary,
    },
    roleBadgeText: {
        fontSize: fontSize.errorFontSize,
        fontFamily: appFonts.medium,
        color: appColors.primary,
        textTransform: 'capitalize',
    },
    summaryDivider: {
        alignSelf: 'stretch',
        height: 1,
        backgroundColor: appColors.borderColor,
        marginVertical: 14,
    },
    infoRow: {
        flexDirection: 'row',
        alignItems: 'center',
        alignSelf: 'stretch',
        gap: 12,
        paddingVertical: 6,
    },
    infoIcon: {
        height: 36,
        width: 36,
        borderRadius: 18,
        backgroundColor: appColors.lightPrimary,
        alignItems: 'center',
        justifyContent: 'center',
    },
    infoLabel: {
        fontSize: fontSize.errorFontSize,
        fontFamily: appFonts.medium,
        color: appColors.grey,
    },
    infoValue: {
        fontSize: fontSize.smallFontSize,
        fontFamily: appFonts.medium,
        color: appColors.lightDark,
        marginTop: 2,
    },
    fieldGrid: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        columnGap: 20,
        rowGap: 14,
    },
    fieldCol: {
        flex: 1,
        minWidth: 200,
    },
    detailValue: {
        fontSize: fontSize.smallerFontSize,
        fontFamily: appFonts.medium,
        color: appColors.dark,
        marginTop: 4,
    },
    outlineButton: {
        paddingHorizontal: 16,
        paddingVertical: 7,
        minHeight: 36,
        borderRadius: 7,
        borderWidth: 1,
        borderColor: appColors.primary,
        backgroundColor: appColors.light,
        justifyContent: 'center',
        alignItems: 'center',
    },
    pinRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 12,
    },
    pinMask: {
        fontSize: fontSize.mediumFontSize,
        fontFamily: appFonts.bold,
        color: appColors.dark,
        letterSpacing: 2,
        marginTop: 2,
    },
})